import React, { useEffect, useState } from 'react'
import { v2_projects, v2_ships } from '../../../../actions/v2/projectAndVessel';
import { v2_yards } from '../../../../actions/v2/masterData';

const SearchFilter = ({ onSearch }) => {
    const [state, setState] = useState({
        yard: { name: 'yard', value: '', options: [] },
        ship: { name: 'ship', value: '', options: [] },
        startDate: { name: 'startDate', value: '' },
        endDate: { name: 'endDate', value: '' },
    })
    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value,
            },
        }));
    };

    const handleSubmit = () => {
        // e.preventDefault();
        // Implement search logic here using searchState values
        onSearch(btoa(JSON.stringify({
            yardId: state.yard.value,
            shipId: state.ship.value,
            startDate: state.startDate.value,
            endDate: state.endDate.value,

        })))
    };

    useEffect(() => {
        v2_yards().then((res) => {
            if (res.status) {
                setState((prev) => ({
                    ...prev,
                    yard: { ...prev.yard, options: res.result },
                }));
            }
        });


    }, []);

    useEffect(() => {
        v2_ships(null, null, state.yard.value).then((res) => {
            if (res.status) {
                setState((prev) => ({
                    ...prev,
                    ship: { ...prev.ship, options: res.result },
                }));
            }
        });

    }, [state.yard.value]);

    useEffect(() => {
        handleSubmit()
    }, [state.yard.value, state.ship.value, state.startDate.value, state.endDate.value])


    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body card-body-search">
                        <div
                            className="row gy-12 gx-12 align-items-center"
                        >
                            <div className="row">

                                <div className="form-group col-md-2">
                                    <label htmlFor="inputEmail4" className="col-form-label">
                                        Yard
                                    </label>
                                    <select className="form-select"
                                        value={state.yard.value}
                                        name={state.yard.name}
                                        onChange={handleChange}
                                    >
                                        <option value="">All yards</option>
                                        {state.yard.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.YARD_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inputEmail4" className="col-form-label">
                                        Hull
                                    </label>
                                    <select className="form-select"
                                        value={state.ship.value}
                                        name={state.ship.name}
                                        onChange={handleChange}
                                    >
                                        <option value="">All Hull</option>

                                        {state.ship.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.HULL_NUMBER} - {item.SHIP_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inputState" className="col-form-label">
                                        Start Date
                                    </label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="START_DATE"
                                        value={state.startDate.value}
                                        name={state.startDate.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inputState" className="col-form-label">
                                        End Date
                                    </label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={state.endDate.value}
                                        name={state.endDate.name}
                                        onChange={handleChange}
                                        id="END_DATE"
                                    />
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="form-group col-md-12">
                                   
                                    <button
                                        type="submit"
                                        style={{
                                            backgroundImage: "linear-gradient(90deg, #6895b4, #265578)"
                                        }}
                                        className="btn btn-primary waves-effect btn-label waves-light"
                                        fdprocessedid="o4l2kzc"
                                    >
                                        <i className="bx bx-cloud-download label-icon" /> Download All
                                        Records
                                    </button>
                                    
                                </div>
                            </div> */}
                        </div>
                    </div>
                    {/* end card body */}
                </div>
                {/* end card */}
            </div>
            {/* end col */}
        </div>

    )
}

export default SearchFilter